export function isCurrentShiftBanned(
  currentShiftId: string | null | undefined,
  bannedShiftIds: readonly string[] | null | undefined
): boolean {
  const normalizedCurrentShiftId = currentShiftId?.trim();
  if (!normalizedCurrentShiftId || !bannedShiftIds?.length) return false;

  return bannedShiftIds.some(
    (bannedShiftId) => bannedShiftId.trim() === normalizedCurrentShiftId
  );
}
